import { attr, belongsTo } from '@ember-data/model';
import BaseModel, { type IResourceName } from 'volta/models/base-model';
import { collectionCommand, resourceCommand as command, _normalize } from 'volta/utils/api';
import { Type } from '@warp-drive/core-types/symbols';
import type { ISettings } from 'volta/models/types/settings';
import type Warehouse from 'volta/models/warehouse';

export const ConfigResourceName: IResourceName = {
  singular: 'config',
  plural: 'configs'
};

const Commands = {
  OverrideForWarehouse: 'OverrideForWarehouse'
};

/**
 * @class Config
 * @extends BaseModel
 */
export default class Config extends BaseModel {
  /**
   * Collection commands
   */

  static overrideForWarehouse = collectionCommand<{ warehouseId: string }, Config, typeof Config>(
    Commands.OverrideForWarehouse
  );

  @belongsTo<Warehouse>('warehouse', { async: false, inverse: null })
  declare warehouse: Warehouse;

  /**
   * @property settings Actual settings payload
   */
  @attr() settings!: ISettings;

  /** Commands  */

  updateSetting = command('UpdateSetting');
  updateTimeZone = command('UpdateTimeZone');
  updateLocale = command('UpdateLocale');
  updateWeekendDays = command('UpdateWeekendDays');
  updateAlert = command('UpdateAlert');
  updateDemandCalculation = command('UpdateDemandCalculation');
  updatePlanningProjection = command('UpdatePlanningProjection');
  updateSupplyGeneration = command('UpdateSupplyGeneration');
  updateDefaultBuffer = command('UpdateDefaultBuffer');
  updateLtCategoryMake = command('UpdateLtCategoryMake');
  updateLtCategoryBuy = command('UpdateLtCategoryBuy');
  updateLtCategoryDistribute = command('UpdateLtCategoryDistribute');
  updateVarCategoryMake = command('UpdateVarCategoryMake');
  updateVarCategoryBuy = command('UpdateVarCategoryBuy');
  updateVarCategoryDistribute = command('UpdateVarCategoryDistribute');
  updatePoWorkbench = command('UpdatePOWorkbench');
  updateBomExplosion = command('UpdateBomExplosion');

  [Type] = 'config' as const;
}
